import { setFlag } from 'controllers/flags';
import {
  CREATE_JOB_IGNORE_FIELDS,
  DEFAULT_LOCATIONS_INDIA,
  DEFAULT_LOCATIONS_USA,
} from './constants';

export const validateJobForm = (selectedJob) => {
  const fields = Object.entries(selectedJob);
  let validation = true;

  fields.forEach(([key, value]) => {
    if (!CREATE_JOB_IGNORE_FIELDS.includes(key) && isEmpty(value)) {
      setFlag('error', true);
      validation = false;
    }

    if (
      (key === 'maxExperience' && value === null) ||
      (key === 'minExperience' && value === null)
    ) {
      setFlag('error', true);
      validation = false;
    }
  });

  if (validation) {
    setFlag('error', false);
  }
  return validation;
};

export const isEmpty = (value) => {
  if (
    !value ||
    (typeof value !== 'number' && !value.length) ||
    (typeof value === 'number' && value === 0)
  ) {
    return true;
  }
  return false;
};

export const getDefaultLocations = (organizationLocation) => {
  if (!organizationLocation) {
    return DEFAULT_LOCATIONS_USA;
  }
  const locations = organizationLocation.split(',');
  if (Array.isArray(locations) && locations.length > 1) {
    const country = organizationLocation.split(',')[1].trim().toLowerCase();
    if (country === 'india') {
      return DEFAULT_LOCATIONS_INDIA;
    }
  }
  return DEFAULT_LOCATIONS_USA;
};
